import { useCallback, useEffect, useMemo, useState } from 'react';
import { Style, fetchStyles } from '../../garments';

const getRandomInt = (max: number) => {
  return Math.floor(Math.random() * max);
};

export const useProductList = () => {
  const [viewType, setViewType] = useState({ grid: true });
  const [styles, setStyles] = useState<Style[]>([]);

  // Retrieve data.
  useEffect(() => {
    (async () => {
      const styles = await fetchStyles();
      setStyles(styles);
    })();
  }, []);

  const changeViewType = useCallback(() => {
    setViewType({
      grid: !viewType.grid,
    });
  }, [viewType]);

  const items = useMemo(() => {
    if (!styles.length) {
      return [];
    }
    // Random featuring.
    const subset = Array.from({ length: 12 }, () => {
      return styles[getRandomInt(styles.length)];
    });
    return subset.map(s => ({
      id: s.id,
      image: s.preview,
      name: s.name,
      price: 100 * getRandomInt(10),
    }));
  }, [styles]);

  return { items, viewType, changeViewType };
};
